import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const WarningMessage = ({time}) => {
 
  const [open, setOpen] = useState(true);

  return (
    open && time &&  (
      <Alert
        severity="warning"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        style={{marginTop:'15px'}}
      >
     
        The summary view was generated on <strong>{time}</strong>. Please regenerate the Summary View if there are any updates to the{' '}
        <strong>Sum Insured</strong> table to reflect the latest changes.
      </Alert>
    )
  );
};

export default WarningMessage;
